/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../cart-service-apis/restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/subcart';

/**
 * externalCartDeleteItem
 * url - /checkout/{apiversion}/cart/{cartId}/extcart/{variantId}/?brand={brandId}
 *
 * @param {Object} wcEnv
 * @param {String} jwtToken
 * @param {String} extCartId
 * @param {String} variantId
 */
const externalCartDeleteItem = ({
    env, jwtToken, orderId, extCartItemId,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${orderId}${RESOURCE_PAGE_ACTION}/${extCartItemId}`;

    return restClient.deleteRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default externalCartDeleteItem;
